import { logout } from '../store/modules/login';
import { addFeedback } from '../store/modules/feedback';

const handleApiError = json => {
  if (json.error === 'Unauthenticated.') {
    if (
      `${window.location.origin}/` !== `${window.location.href}` &&
      window.location.href.indexOf('password/reset') === -1 &&
      window.location.href.indexOf('login') === -1
    ) {
      return logout();
    }
  } else {
    return addFeedback('error', json.error);
  }
};

export default handleApiError;



// WEBPACK FOOTER //
// ./src/helpers/handleApiError.js